import React from 'react'

const TaxInvoice = ({ invoiceRef, taxInvoice }) => {
  return (
    <div style={{ width: "0", height: "0", overflow: "hidden" }}>
      <div
        ref={invoiceRef}
        style={{
          margin: 0,
          padding: "60px 10px 1px 10px",
          fontSize: "13pt",
          backgroundColor: "white",
          zIndex: "-1",
          width: "1350px",
          lineHeight: "1.8",
        }}
      >
        <div
          style={{
            maxWidth: "100%",
            margin: "0 auto",
            padding: "0px",
          }}
        >
          {/* Header Section */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "200px",
                marginRight: "20px",
              }}
            >
              <img src="/img/report/logo.jpg" alt="Company Logo" style={{ width: "100%" }} />
            </div>
            <div style={{ flexGrow: 1 }}>
              <h1
                className='font-report'
                style={{
                  fontSize: "20pt",
                  fontWeight: "bold",
                  margin: 0,
                }}
              >
                บริษัท แอดวานซ์ เน็ตเวิร์ค เทคโนโลยี แอนด์ เซอร์วิส จำกัด
              </h1>
              <h2
                className='font-report'
                style={{
                  fontSize: "20pt",
                  fontWeight: "bold",
                  margin: "0 0 5px 0",
                }}
              >
                Advance Network Technology & Services Co., Ltd.
              </h2>
              <p
                className='font-report'
                style={{
                  fontSize: "13pt",
                  margin: 0,
                }}
              >
                42/92 ซอยเลี่ยงเมืองนนทบุรี 10 ตำบล บางกระสอ อำเภอ เมืองนนทบุรี จังหวัด นนทบุรี 11000
              </p>
              <p
                className='font-report'
                style={{
                  fontSize: "13pt",
                  margin: 0,
                }}
              >
                42/92 Nonthaburi Bypath Road Soi 10, Bang kraso, Mueang Nonthaburi, Nonthaburi 11000
              </p>
              <p
                className='font-report'
                style={{
                  fontSize: "13pt",
                  margin: 0,
                }}
              >
                Tel.02-077-4534 Tax ID : 0125558010311 (Head office)
              </p>
            </div>
          </div>

          {/* Title */}
          <div
            style={{
              textAlign: "center",
              fontSize: "18pt",
              fontWeight: "bold",
              margin: "10px 0",
            }}
          >
            <p className='font-report' style={{ fontSize: "26px", fontWeight: "bold", marginBottom: 0 }}>ใบเสร็จรับเงิน/ใบกำกับภาษี</p>
            <p className='font-report' style={{ fontSize: "26px", fontWeight: "bold", marginBottom: 0 }}>Receipt/Tax Invoice</p>
          </div>

          {/* Customer and Invoice Information */}
          <div
            style={{
              display: "flex",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                border: "1px solid #000",
                padding: "10px",
                flexGrow: 1,
                marginRight: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "22px",
                paddingRight: "10px",
                width: "62%",
              }}
            >
              <div style={{ display: "flex", marginBottom: "5px" }} >
                <div className='font-report' style={{ fontWeight: "bold", width: "200px" }}>ชื่อลูกค้า/Name</div>
                <div className='font-report' style={{ flexGrow: 1 }}>{taxInvoice.customer_name} </div>
              </div>
              <div style={{ display: "flex", marginBottom: "5px" }}>
                <div className='font-report' style={{ fontWeight: "bold", width: "200px" }}>ชื่อบริษัท/Company</div>
                <div className='font-report' style={{ flexGrow: 1 }}>{taxInvoice.customer_company}</div>
              </div>
              <div style={{ display: "flex", marginBottom: "5px" }}>
                <div style={{ display: "flex", marginBottom: "5px" }}>
                  <div className='font-report' style={{ fontWeight: "bold", width: "200px" }}>สาขา/Branch</div>
                  <div className='font-report' style={{ flexGrow: 1 }}>{taxInvoice.customer_branch}</div>
                </div>
                <div style={{ display: "flex", marginBottom: "5px", paddingLeft: "100px" }}>
                  <div className='font-report' style={{ flexGrow: 1, fontWeight: "bold" }}>เลขประจำตัวผู้เสียภาษีอากร/Tax ID</div>
                  <div className='font-report' style={{ whiteSpace: "nowrap", paddingLeft: "20px" }}>{taxInvoice.customer_taxid}</div>
                </div>
              </div>
              <div style={{ display: "flex", marginBottom: "5px" }}>
                <div className='font-report' style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>ที่อยู่/Address</div>
                <div className='font-report' style={{ flexGrow: 1, paddingLeft: "20px", paddingRight: "40px" }}>{taxInvoice.customer_address} </div>
              </div>
              <div style={{ display: "flex", marginBottom: "5px" }}>
                <div className='font-report' style={{ fontWeight: "bold", width: "150px" }}>โทร/Tel.</div>
                <div className='font-report' style={{ flexGrow: 1 }}>{taxInvoice.customer_tel}</div>
              </div>
            </div>
            <div
              style={{
                border: "1px solid #000",
                padding: "10px",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                gap: "22px",
                width: "38%",
                paddingRight: "10px",

              }}
            >
              <div style={{ display: "flex", marginBottom: "5px" }}>
                <div className='font-report' style={{ fontWeight: "bold", width: "300px" }}>
                  เลขที่ใบเสร็จ/ใบกำกับภาษี
                  <br />
                  Receipt/Tax invoice no.
                </div>
                <div className='font-report' style={{ flexGrow: 1 }}>{taxInvoice.receipt_no}</div>
              </div>
              <div style={{ display: "flex", marginBottom: "5px" }}>
                <div className='font-report' style={{ fontWeight: "bold", width: "300px" }}>วันที่เอกสาร/Date</div>
                <div className='font-report' style={{ flexGrow: 1 }}>{taxInvoice.taxinvoice_date}</div>
              </div>
              <div style={{ display: "flex", marginBottom: "5px" }}>
                <div className='font-report' style={{ fontWeight: "bold", width: "300px" }}>เลขที่ใบแจ้งหนี้/Invoice No.</div>
                <div className='font-report' style={{ flexGrow: 1 }}>{taxInvoice.receipt_invoice_no}</div>
              </div>
            </div>
          </div>

          {/* Invoice Items Table */}
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#f2f2f2",
                    width: "140px",
                  }}
                  className='font-report'

                >
                  ลำดับ
                  <br />
                  (No.)
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#f2f2f2",
                  }}
                  className='font-report'
                >
                  รายการ
                  <br />
                  (Description)
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#f2f2f2",
                    width: "160px",
                  }}
                  className='font-report'
                >
                  จำนวน
                  <br />
                  (Unit Amount)
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#f2f2f2",
                    width: "100px",
                  }}
                  className='font-report'
                >
                  หน่วย
                  <br />
                  (Unit)
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#f2f2f2",
                    width: "150px",
                  }}
                  className='font-report'
                >
                  ราคา/หน่วย
                  <br />
                  (Price/Unit)
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#f2f2f2",
                    width: "100px",
                  }}
                  className='font-report'
                >
                  ส่วนลด
                  <br />
                  (Discount)
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#f2f2f2",
                    width: "150px",
                  }}
                  className='font-report'
                >
                  จำนวนเงิน
                  <br />
                  (Amount)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr >
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                  }}
                  className='font-report'
                >
                  1
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_namedesc}
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "right",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_cost}
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                  }}
                  className='font-report'
                >
                  เครดิต
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "right",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_costperunit}
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                  }}
                  className='font-report'
                ></td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "right",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_cost}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={4}
                  rowSpan={5}
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                    verticalAlign: "top",
                  }}
                  className='font-report'
                >
                  <strong className='font-report' >หมายเหตุ</strong> ใบเสร็จรับเงินฉบับนี้จะสมบูรณ์ต่อเมื่อมีลายเซ็นผู้รับมออำนาจและได้รับชำระเงินเรียบร้อยแล้ว
                  <br />
                  <strong className='font-report' >Remark</strong>
                </td>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                  }}
                  className='font-report'
                >
                  รวมเงิน
                  <br />
                  Subtotal
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "right",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_cost}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                  }}
                  className='font-report'
                >
                  ค่าธรรมเนียม
                  <br />
                  Service Fee
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "right",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_sum_cost_with_fee}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                  }}
                  className='font-report'
                >
                  ส่วนลด
                  <br />
                  Discount
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "right",
                  }}
                  className='font-report'
                ></td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                  }}
                  className='font-report'
                >
                  มูลค่าหลังหักส่วนลด
                  <br />
                  Total Amount
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "right",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_sum_cost}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                    borderRight: "none"
                  }}
                  className='font-report'
                >
                  ภาษีมูลค่าเพิ่ม
                  <br />
                  VAT
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                    borderLeft: "none"
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_tax_percentage}
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "right",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_tax}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                  }}
                  className='font-report'
                >
                  รวม 1 รายการ

                </td>
                <td
                  colSpan={3}
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "center",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_sum_cost_thai_text}
                  <br />
                  {taxInvoice.package_sum_cost_eng_text}
                </td>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                  }}
                  className='font-report'
                >
                  จำนวนเงินทั้งสิ้น
                  <br />
                  Net Amount
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "right",
                  }}
                  className='font-report'
                >
                  {taxInvoice.package_sum_cost_with_tax}
                </td>
              </tr>
            </tbody>
          </table>

          {/* Payment Section */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "20px",
            }}
          >

            <div
              style={{
                padding: "0",
                flexGrow: 1,
              }}
            >
              <table
                style={{
                  width: "100%",
                  height: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th
                      colSpan={2}
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <p className='font-report' style={{ marginBottom: "0" }} >ชำระโดย</p>
                      <p className='font-report' style={{ marginBottom: "0" }} >(Paid by)</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                        marginTop: "15px",
                        width: "20%"
                      }}
                    >
                      <input type='checkbox' checked style={{ marginTop: "15px" }} />
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "left",
                      }}
                      className='font-report'
                    >
                      โมบายแบงก์กิ้ง/ Mobile Banking
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              style={{
                padding: "0",
                flexGrow: 1,
                width: "60%",
              }}
            >
              <table
                style={{
                  width: "100%",
                  height: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                      }}
                      className='font-report'
                    >
                      ธนาคาร
                      <br />
                      (Bank)
                    </th>
                    <th
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                      className='font-report'
                    >
                      สาขา
                      <br />
                      (Branch)
                    </th>
                    <th
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                      className='font-report'
                    >
                      เลขที่เช็ค/เลขที่บัญชี
                      <br />
                      (Check No./Account No.)
                    </th>
                    <th
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                      className='font-report'
                    >
                      ลงวันที่
                      <br />
                      (Date)
                    </th>
                    <th
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                      className='font-report'
                    >
                      จำนวนเงิน
                      <br />
                      (Amount)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ visibility: "collapse" }}>empty</span>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    ></td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    ></td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    ></td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    ></td>
                  </tr>
                  <tr>
                    <td
                      colSpan={2}
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "left",
                      }}
                      className='font-report'
                    >
                      จำนวนเงิน/Total Amount
                    </td>
                    <td
                      colSpan={2}
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "right",
                      }}
                      className='font-report'
                    >
                      {taxInvoice.package_sum_cost_with_tax}
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                      }}
                      className='font-report'
                    >
                      บาท/Bath
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div >
            <div
              style={{
                textAlign: "center",
                fontStyle: "italic",
                margin: "20px 0",
              }}
              className='font-report'
            >
              ใบเสร็จรับเงิน/ ใบกำกับภาษีฉบับนี้จะสมบูรณ์ต่อเมื่อมีลายเซ็นพร้อมตราประทับของบริษัท
              <br />
              เรียกเก็บเงินจากธนาคารได้ครบถ้วนแล้วหรือบริษัทฯ ได้รับเงินโอนเข้าบัญชีครบถ้วนแล้ว
            </div>
            <div
              style={{
                textAlign: "center",
                marginTop: "80px",
                // position: "relative",
              }}
            >
              {/* <p className='font-report' >
                ในนาม บริษัท แอดวานซ์ เน็ตเวิร์ค เทคโนโลยี แอนด์ เซอร์วิส จำกัด
                <br />
                Advance Network Technology & Service Co.,Ltd.
              </p> */}
              <div 
              // style={{
              //   position: "absolute",
              //   top: "50%",
              //   left: "50%",
              //   transform: "translate(-50%, -50%)"
              // }} 
              className='font-report' >
                {/* <img
                  src="/img/report/signature.png"
                  alt="Authorized Signature"
                  style={{ width: "150px", marginBottom: "10px" }}
                /> */}
                <hr style={{ width: "350px", margin: "0 auto", borderTop: "2px solid #000" }} />
              </div>
              <p className='font-report' >ผู้มีอำนาจลงนาม/Authorized Signature</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default TaxInvoice